angular.module('display').run(['$templateCache', function($templateCache) {
  'use strict';

  $templateCache.put('/display/views/display.html',
    "<div class=\"container-fluid\">\r" +
    "\n" +
    "    <div class=\"panel panel-primary\">\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"panel-header panel-header-secondary\">\r" +
    "\n" +
    "            <img class=\"rounded-corner-md border-width-md extra-dark-grey-border list-item-thumbnail\"\r" +
    "\n" +
    "                 lazy-src=\"{{$ctrl.patient.PatientId | apPatientThumbnailSrc:50:50}}\">\r" +
    "\n" +
    "            <div class=\"panel-title panel-title-secondary\">\r" +
    "\n" +
    "                <div class=\"patient-name\">{{$ctrl.patient.FirstName + ' ' + $ctrl.patient.LastName}}</div>\r" +
    "\n" +
    "                <ap-date-formatter date=\"{{$ctrl.patient.BirthDate}}\" format=\"long-date\"></ap-date-formatter>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <nav class=\"navbar navbar-default\">\r" +
    "\n" +
    "            <div class=\"navbar-header\">\r" +
    "\n" +
    "                <button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\">\r" +
    "\n" +
    "                    <span class=\"sr-only\">Toggle navigation</span>\r" +
    "\n" +
    "                    <span class=\"icon-bar\"></span>\r" +
    "\n" +
    "                    <span class=\"icon-bar\"></span>\r" +
    "\n" +
    "                    <span class=\"icon-bar\"></span>\r" +
    "\n" +
    "                </button>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "            <div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-1\">\r" +
    "\n" +
    "                <ul class=\"nav navbar-nav\">\r" +
    "\n" +
    "                    <li><a ng-click=\"$ctrl.backToSearch()\"><i class=\"fa fa-search\" aria-hidden=\"false\" style=\"padding-right: 5px\"></i>Back to Search</a></li>\r" +
    "\n" +
    "                    <li class=\"active\"><a ng-click=\"$ctrl.selectPreviousNote()\">Previous Note<span class=\"sr-only\">(current)</span></a></li>\r" +
    "\n" +
    "                    <li><a ng-click=\"$ctrl.multiVisitModal()\">Download Multiple</a></li>\r" +
    "\n" +
    "                    <li ng-if=\"$ctrl.showAttestation\"><a ng-click=\"$ctrl.openAttestation()\">Attestation</a></li>\r" +
    "\n" +
    "                </ul>\r" +
    "\n" +
    "                <ul class=\"nav navbar-nav navbar-right\">\r" +
    "\n" +
    "                    <li><a ng-click=\"$ctrl.selectNextNote()\">Next Note</a></li>\r" +
    "\n" +
    "                    <li class=\"dropdown\">\r" +
    "\n" +
    "                        <a class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">Notes<span class=\"caret\"></span></a>\r" +
    "\n" +
    "                        <ul class=\"dropdown-menu\">\r" +
    "\n" +
    "                            <li>\r" +
    "\n" +
    "                                <a ng-repeat=\"visit in $ctrl.visitNoteList\" ng-click=\"$ctrl.selectVisitNote($index)\">{{$ctrl.formatDate(visit.Date)}}</a>\r" +
    "\n" +
    "                            </li>\r" +
    "\n" +
    "                        </ul>\r" +
    "\n" +
    "                    </li>\r" +
    "\n" +
    "                </ul>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </nav>\r" +
    "\n" +
    "\r" +
    "\n" +
    "        <div class=\"panel panel-default panel-flush\">\r" +
    "\n" +
    "            <div class=\"panel-body\">\r" +
    "\n" +
    "                <div class=\"row\">\r" +
    "\n" +
    "                    <div class=\"col-xs-12 col-xs-flush\">\r" +
    "\n" +
    "                        <ap-document-viewer-with-download\r" +
    "\n" +
    "                            disable-inline-pdf=\"$ctrl.disableInlinePdf\"\r" +
    "\n" +
    "                            document-id=\"$ctrl.documentId\"\r" +
    "\n" +
    "                            enable-download=\"$ctrl.documentId\"\r" +
    "\n" +
    "                            document-download=\"$ctrl.downloadVisit(documentId)\"\r" +
    "\n" +
    "                            document-load=\"$ctrl.getVisit(documentId)\"\r" +
    "\n" +
    "                        ></ap-document-viewer-with-download>\r" +
    "\n" +
    "                    </div>\r" +
    "\n" +
    "                </div>\r" +
    "\n" +
    "            </div>\r" +
    "\n" +
    "        </div>\r" +
    "\n" +
    "\r" +
    "\n" +
    "    </div>\r" +
    "\n" +
    "</div>"
  );

}]);
